import notify from 'devextreme/ui/notify';
import React, { useCallback, useEffect, useState } from 'react';
import { getItemApi, postApi } from '../../apiUtils';
import { Loader } from '../../components/loader/Loader';
import {
  CreateFormData,
  OutlookPluginTaskCreateForm,
} from '../../forms/outlookPlugin/OutlookPluginTaskCreateForm';
import { base64ToFile } from '../../functions/files';
import { ApplicationUser } from '../../types/applicationUser.types';
import { Customer } from '../../types/customer.types';
import { API_URL } from '../../utils/apiUrl';

export const OutlookPluginTaskCreate = () => {
  const [user, setUser] = useState<ApplicationUser | null>();
  const [dataFromPlugin, setDataFromBlugin] = useState<any>(null);
  const [defaultFormData, setDefaultFormData] = useState<CreateFormData | null>();
  const [assetClassId, setAssetClassId] = useState<number | null>(null);
  const [attachmentsFromPlugin, setAttachmentsFromPlugin] = useState<File[]>([]);

  // @ts-ignore
  window.outlookPluginSignIn = (arg) => {
    const credentials = JSON.parse(arg);
    signIn(credentials.login, credentials.password, credentials.assetClassId, credentials.platform);
  };

  // @ts-ignore
  window.outlookPluginSetDefaultValues = (arg) => {
    const formData = JSON.parse(arg);
    handleFormData(formData);
  };

  // @ts-ignore
  window.outlookPluginAddAttachment = (arg) => {
    const fileData = JSON.parse(arg);
    const file = base64ToFile(fileData.blob, fileData.fileName, fileData.contentType);
    setAttachmentsFromPlugin([...attachmentsFromPlugin, file]);
  };

  const signIn = async (
    login: string,
    password: string,
    assetClassId: number,
    platform: string,
  ) => {
    await postApi<ApplicationUser>({
      url: `${API_URL.LOGIN}`,
      data: { login: login, password, assetClassId, platform },
      callAfterSuccess: (result) => {
        setUser(result);
        setAssetClassId(assetClassId);
      },
      callAfterError: (err) => {
        notify('Sign in error' + err, 'error');
      },
    });
  };

  const getCustomer = async (inboxEmail: string) => {
    let customer: any = null;
    await getItemApi<Customer>({
      url: `${API_URL.CUSTOMER_ITEM_BY_EMAIL_INBOX}?emailInboxArr=${inboxEmail}`,
      params: {},
      callAfterSuccess: (result: Customer) => {
        customer = result;
      },
      callAfterError(arg) {
        customer = null;
      },
      hideNotifications: true,
    });

    return customer;
  };

  const getTemplates = useCallback(
    async (
      personalNumber: number,
      assetClass: number,
      inboxEmail: string,
      inboxFolderName: string,
      requestorEmail: string,
    ) => {
      return await getItemApi<any>({
        url: `${API_URL.TASK_TEMPLATE_FOR_USER}?userId=${personalNumber}&assetClassId=${assetClass}&inboxEmail=${inboxEmail}&inboxFolderName=${inboxFolderName}&requestorEmail=${requestorEmail}`,
        params: {},
        hideNotifications: true,
      });
    },
    [user, assetClassId],
  );

  const handleFormData = (formData: any) => {
    setDataFromBlugin(formData);
  };

  useEffect(() => {
    if (!dataFromPlugin || !user || !assetClassId) return;
    setDefaultValues();
  }, [dataFromPlugin, user, assetClassId]);

  const setDefaultValues = async () => {
    if (!user || !assetClassId) return;
    const customer: any = await getCustomer(dataFromPlugin.inboxEmail);

    let data: CreateFormData = {
      customerId: null,
      requestorName: dataFromPlugin.requestorName,
      requestorEmail: dataFromPlugin.requestorEmail,
      taskName: dataFromPlugin.taskName,
      description: dataFromPlugin.description,
      attachmentsCount: dataFromPlugin.attachmentsCount,
      emailReceived: dataFromPlugin.emailReceived,
      inboxEmail: dataFromPlugin.inboxEmail,
      inboxFolderName: dataFromPlugin.inboxFolder,
      creationTime: dataFromPlugin.emailReceived,
    };

    if (customer) data = { ...data, customerId: customer.id };

    const template: any = await getTemplates(
      user.personalNumber,
      assetClassId,
      dataFromPlugin.inboxEmail,
      dataFromPlugin.inboxFolder,
      dataFromPlugin.requestorEmail,
    );

    if (!template) {
      setDefaultFormData(data);
      return;
    }

    if (
      template.inboxEmail === dataFromPlugin.inboxEmail &&
      template.inboxFolderName === dataFromPlugin.inboxFolder
    ) {
      if (!data.customerId)
        // Předvyplněné z mailu
        data = { ...data, customerId: template.customerId };
      if (!data.requestorName) data = { ...data, requestorName: template.requestorName };

      // Nechodí z mailu
      if (template.customerProjectId)
        data = { ...data, customerProjectId: template.customerProjectId };
      if (template.typeId) data = { ...data, typeId: template.typeId };
      if (template.assetId) data = { ...data, assetId: template.assetId };
      if (template.capacityCategoryId)
        data = { ...data, capacityCategoryId: template.capacityCategoryId };
      if (template.responsiblePersonId)
        data = { ...data, responsiblePersonId: template.responsiblePersonId };
      if (template.requestorPhone) data = { ...data, requestorPhone: template.requestorPhone };
    }

    setDefaultFormData(data);
  };

  // useEffect(() => {
  //   let string = '{"login":"workflow","password":"123","assetClassId":4,"platform":"OUTLOOK"}';
  //   if (!user) {
  //     const credentials = JSON.parse(string);
  //     signIn(
  //       credentials.login,
  //       credentials.password,
  //       credentials.assetClassId,
  //       credentials.platform,
  //     );
  //   }

  //   if (user && assetClassId) {
  //     string =
  //       '{"inboxEmail":"jakub.benes@outlook.com","inboxFolder":"Doručená pošta","emailsTo":"SiStore.Workflow@noreply.github.com;jakub.benes@outlook.com;assign@noreply.github.com","requestorName":"Jaroslav Langer","requestorEmail":"notifications@github.com","taskName":"Re: [Apsys-Group/SiStore.Workflow] Default hodnoty - pro založení požadavku (Issue #601)","description":"<p></p>\\r\\n<p dir=\\"auto\\">Assigned <a class=\\"issue-link js-issue-link\\" data-error-text=\\"Failed to load title\\" data-id=\\"3006203332\\" data-permission-text=\\"Title is private\\" data-url=\\"https://github.com/Apsys-Group/SiStore.Workflow/issues/601\\" data-hovercard-type=\\"issue\\" data-hovercard-url=\\"/Apsys-Group/SiStore.Workflow/issues/601/hovercard\\" href=\\"https://emea01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fgithub.com%2FApsys-Group%2FSiStore.Workflow%2Fissues%2F601&amp;data=05%7C02%7C%7Cc4d6f69c28a0452c930b08dd93975662%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C638829000380822698%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=m%2BEqsuwSnxyC0zHf1ssOw%2FjOqBXWMlegRKKF0ts37Gg%3D&amp;reserved=0\\" originalsrc=\\"https://github.com/Apsys-Group/SiStore.Workflow/issues/601\\">#601</a> to <a class=\\"user-mention notranslate\\" data-hovercard-type=\\"user\\" data-hovercard-url=\\"/users/benes-jakub/hovercard\\" data-octo-click=\\"hovercard-link-click\\" data-octo-dimensions=\\"link_type:self\\" href=\\"https://emea01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fgithub.com%2Fbenes-jakub&amp;data=05%7C02%7C%7Cc4d6f69c28a0452c930b08dd93975662%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C638829000380846194%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=0iW%2Fi%2Fs%2B%2FvkwG8ar%2BOjUTIn0WqUv7MP8aAyeK8rULmQ%3D&amp;reserved=0\\" originalsrc=\\"https://github.com/benes-jakub\\">@benes-jakub</a>.</p>\\r\\n\\r\\n<p style=\\"font-size:small;-webkit-text-size-adjust:none;color:#666;\\">—<br>Reply to this email directly, <a href=\\"https://emea01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fgithub.com%2FApsys-Group%2FSiStore.Workflow%2Fissues%2F601%23event-17668920562&amp;data=05%7C02%7C%7Cc4d6f69c28a0452c930b08dd93975662%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C638829000380861082%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=oVDUT02X5NXrFR%2Fa2BVGkYWAG3EF7%2FZwCOGmTUStLB4%3D&amp;reserved=0\\" originalsrc=\\"https://github.com/Apsys-Group/SiStore.Workflow/issues/601#event-17668920562\\">view it on GitHub</a>, or <a href=\\"https://emea01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fgithub.com%2Fnotifications%2Funsubscribe-auth%2FADLAVM2AYQ6XI47KUSE2D4L26RQUFAVCNFSM6AAAAAB3OFX26OVHI2DSMVQWIX3LMV45UABCJFZXG5LFIV3GK3TUJZXXI2LGNFRWC5DJN5XDWMJXGY3DQOJSGA2TMMQ&amp;data=05%7C02%7C%7Cc4d6f69c28a0452c930b08dd93975662%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C638829000380875861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=K0bgqAJa3Y2kAzN%2BKp9ldHSFT2yqFeYOHC4ThiH2Nuo%3D&amp;reserved=0\\" originalsrc=\\"https://github.com/notifications/unsubscribe-auth/ADLAVM2AYQ6XI47KUSE2D4L26RQUFAVCNFSM6AAAAAB3OFX26OVHI2DSMVQWIX3LMV45UABCJFZXG5LFIV3GK3TUJZXXI2LGNFRWC5DJN5XDWMJXGY3DQOJSGA2TMMQ\\">unsubscribe</a>.<br>You are receiving this because you were assigned.<img src=\\"https://github.com/notifications/beacon/ADLAVM2WFAI4UM2ZW5SLGML26RQUFA5CNFSM6AAAAAB3OFX26OWGG33NNVSW45C7OR4XAZNWJFZXG5LFIV3GK3TUJZXXI2LGNFRWC5DJN5XKUY3PNVWWK3TUL5UWJTYAAAAAIHJGKTZA.gif\\" height=\\"1\\" width=\\"1\\" alt=\\"\\"><span style=\\"color: transparent; font-size: 0; display: none; visibility: hidden; overflow: hidden; opacity: 0; width: 0; height: 0; max-width: 0; max-height: 0; mso-hide: all\\">Message ID: <span>&lt;Apsys-Group/SiStore</span><span>.</span><span>Workflow/issue/601/issue_event/17668920562</span><span>@</span><span>github</span><span>.</span><span>com&gt;</span></span></p>\\r\\n<script type=\\"application/ld+json\\">[\\r\\n{\\r\\n\\"@context\\": \\"http://schema.org\\",\\r\\n\\"@type\\": \\"EmailMessage\\",\\r\\n\\"potentialAction\\": {\\r\\n\\"@type\\": \\"ViewAction\\",\\r\\n\\"target\\": \\"https://github.com/Apsys-Group/SiStore.Workflow/issues/601#event-17668920562\\",\\r\\n\\"url\\": \\"https://github.com/Apsys-Group/SiStore.Workflow/issues/601#event-17668920562\\",\\r\\n\\"name\\": \\"View Issue\\"\\r\\n},\\r\\n\\"description\\": \\"View this Issue on GitHub\\",\\r\\n\\"publisher\\": {\\r\\n\\"@type\\": \\"Organization\\",\\r\\n\\"name\\": \\"GitHub\\",\\r\\n\\"url\\": \\"https://github.com\\"\\r\\n}\\r\\n}\\r\\n]</script>","attachmentsCount":0,"emailReceived":"2025-05-15T12:00:38.392"}';
  //     handleFormData(JSON.parse(string));
  //   }
  // }, [user, assetClassId]);

  if (
    !user ||
    !defaultFormData ||
    defaultFormData.attachmentsCount !== attachmentsFromPlugin.length ||
    assetClassId === null
  )
    return <Loader />;
  return (
    <div className={'content-block'} style={{ width: '100%' }}>
      <OutlookPluginTaskCreateForm
        user={user}
        defaultFormData={defaultFormData}
        attachmentsFromPlugin={attachmentsFromPlugin}
        disableCustomerId={defaultFormData.customerId !== null}
        assetClassId={assetClassId}
      />
    </div>
  );
};
